import * as React from "react"
import styled from "styled-components"
import ReactPlayer, { ReactPlayerProps } from "react-player"
import { Flex, Button } from "../../components"

export type VideoPlayerLocales = "playBtnLabel"

export interface VideoPlayerProps extends ReactPlayerProps {
	posterUrl?: string
	verticalFormat?: boolean
	locales: Record<VideoPlayerLocales, string>
	playButtonCaption?: string
}

interface VideoPlayerStyledProps {
	verticalFormat?: boolean
	isPlaying?: boolean
}

const VideoPlayerStyled = styled.div<VideoPlayerStyledProps>`
	position: relative;
	width: 100%;

	&:after {
		content: "";
		display: block;
		padding-bottom: 56.25%;
	}

	.react-player {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;

		&__shadow {
			display: none !important;
		}
	}

	.play-btn {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translateY(-50%) translateX(-50%);
		z-index: 1;
	}

	@media screen and (max-width: 744px) {
		&:after {
			padding-bottom: ${(props) =>
				props.verticalFormat && props.isPlaying ? "177.777778%" : "56.25%"};
		}
	}
`

const VideoPlayer: React.FC<VideoPlayerProps> = ({
	posterUrl,
	locales,
	verticalFormat,
	playButtonCaption,
	children,
	...rest
}) => {
	const [hasStarted, setHasStarted] = React.useState(false)
	const [isPlaying, setIsPlaying] = React.useState(false)

	return (
		<Flex w={1} flexDirection="column">
			<VideoPlayerStyled verticalFormat={verticalFormat} isPlaying={isPlaying}>
				<ReactPlayer
					className="react-player"
					width="100%"
					height="100%"
					playing={isPlaying}
					onPlay={() => setIsPlaying(true)}
					onPause={() => setIsPlaying(false)}
					light={hasStarted ? false : posterUrl}
					playIcon={
						<Button
							display={isPlaying ? "none" : "inline-flex"}
							icon="playCircle"
							variant="white"
							textColor="navy"
							className="play-btn"
							onClick={() => setIsPlaying(true)}
						>
							{playButtonCaption !== ""
								? playButtonCaption
								: locales.playBtnLabel}
						</Button>
					}
					onStart={() => setHasStarted(true)}
					{...rest}
				/>
			</VideoPlayerStyled>
			{children}
		</Flex>
	)
}

VideoPlayer.defaultProps = {
	autoPlay: false,
}

export { VideoPlayer }
